import TransactionsOps from "./transactionsOps.service";

const transactionsOpsModule = angular
  .module("app.services.transactionsOps", [])
  .service("TransactionsOps", TransactionsOps);

export default transactionsOpsModule;



// WEBPACK FOOTER //
// ./src/services/transactionsOps/transactionsOps.module.js